import { useQuery } from 'react-query';
import { getCustomQuestions } from '../api/getCustomQuestions';

const useCustomQuestions = (patientID) => {
  const { data, isLoading } = useQuery(['customQuestions', patientID], () => getCustomQuestions(patientID), {
    enabled: !!patientID,
    refetchOnWindowFocus: true,
    staleTime: 50000,
    onError: (error) => {
      console.error('Error fetching custom questions:', error);
    },
  });

  return {
    customQuestions: data?.custom_questions || [],
    isLoading,
  };
};

export default useCustomQuestions;
